import React from 'react'
import styles from './RoleChips.module.scss'

export type RoleChipTone = 'granted' | 'implied'
export type RoleChipSize = 'compact' | 'regular'

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * Granted roles are teal. An implied role is a true light blue, so it reads
   * as not persisted.
   */
  tone: RoleChipTone
  /** Compact for table cells, regular for drawers and forms. */
  size?: RoleChipSize
}

/**
 * One RBAC role as a pill. The single place chip colours and sizes live, so
 * every page that shows a user's roles looks the same.
 */
export default function RoleChip({
  tone,
  size = 'compact',
  className,
  children,
  ...rest
}: Props) {
  const classes = [
    styles.chip,
    tone === 'implied' ? styles.implied : styles.granted,
    size === 'regular' ? styles.regular : styles.compact,
    className,
  ]
    .filter(Boolean)
    .join(' ')
  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  )
}
